export const VALIDATE_AUTHENTICATION_CODE_REQUEST =
  "VALIDATE_AUTHENTICATION_CODE_REQUEST";
export const VALIDATE_AUTHENTICATION_CODE_FAILURE =
  "VALIDATE_AUTHENTICATION_CODE_FAILURE";
export const VALIDATE_AUTHENTICATION_CODE_SUCCESS =
  "VALIDATE_AUTHENTICATION_CODE_SUCCESS";
